import React from 'react';
import { NavLink } from 'react-router-dom';
import './Navbar.css'

const Navbar = () => {
    return (
        <header className="navbar">
            <nav className="navbar-links">
                <NavLink to="/" end>
                    Home
                </NavLink>
                <NavLink to="/experience">Experience</NavLink>
                <NavLink to="/projects">Projects</NavLink>
                <NavLink to="/articles">Articles</NavLink>
                <NavLink to="/contact">Contact</NavLink>
            </nav>
        </header>
    );
};

export default Navbar;
